import { Entity } from "../entity/entity";

export class Controller {

    constructor() {}

    update(entity: Entity, dt: number) {}
}
